import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_KEY;

/**
 * Another Statbox tab (or a second GoTrue client) may already hold
 * lock:sb-*-auth-token. supabase-js throws that as an uncaught promise
 * on visibilitychange / token refresh. Skip the refresh if the lock is busy.
 */
async function authNavigatorLock(name, acquireTimeout, fn) {
  if (typeof navigator === 'undefined' || !navigator.locks?.request) {
    return fn();
  }
  try {
    if (acquireTimeout === 0) {
      const result = await navigator.locks.request(
        name,
        { ifAvailable: true, mode: 'exclusive' },
        async (lock) => {
          if (!lock) return { skipped: true };
          return { skipped: false, value: await fn() };
        },
      );
      if (result?.skipped) return undefined;
      return result?.value;
    }
    return await navigator.locks.request(name, { mode: 'exclusive' }, () => fn());
  } catch (_) {
    return undefined;
  }
}

const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    lock: authNavigatorLock,
  },
});

export default supabase;
